<template>
	<cbs-context-menu
		v-if="productItem.can_update || mixinIsCanCreateProduct"
		v-bind="$attrs"
		:class="['todo-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'todo-context-menu-list' }"
	>
		<!-- Add Qoute -->
		<!-- <div v-if="mixinIsCanCreateProduct" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickAddQuote', productItem)">
			<i class="nucleo mr-3 nucleo-recipe-create-3" />
			{{ $t("Actions.AddQuote") }}
		</div> -->
		<!-- Edit -->
		<div v-if="productItem.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', productItem)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>
		<!-- delete -->
		<div v-if="productItem.can_delete" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', productItem)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("Actions.Delete") }}
		</div>
	</cbs-context-menu>
	<span v-else></span>
</template>

<script>
import { productPermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "ProductContextMenu",
	mixins: [getUserPermissions({ ...productPermissions })],
	components: { CbsContextMenu },
	props: {
		productItem: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickCancel: {},
		onClickRecreate: {},
		onClickCreateRequest: {}
	},
	data() {
		return {
			statusActions: {
				0: "",
				1: "onCompleteTodo",
				2: "onClickCancel",
				4: "onSetStatusTodo",
				5: "onSetStatusTodo",
				7: "onClickReject"
			}
		};
	},
	methods: {
		statusEmits(key) {
			return this.statusActions[key];
		}
	}
};
</script>

<style lang="scss" scoped>
.todo-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.todo-context-menu-list {
	.todo-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
